import { Component, OnInit, Input, ChangeDetectorRef, Output } from '@angular/core';
import { FormBuilder, Validators, FormArray } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import { RouterLink } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { FlexModule } from '@angular/flex-layout/flex';
import { NgIf, NgFor, JsonPipe } from '@angular/common';

@Component({
    selector: 'app-quotation-cart-details',
    templateUrl: './quotation-details.component.html',
    styleUrls: ['./quotation-details.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        FlexModule,
        MatDividerModule,
        NgFor,
        RouterLink,
        JsonPipe,
    ],
})
export class QuotationDetailsViewerComponent implements OnInit {
    constructor(public translate: TranslateService) {}

    //quotatin item list data
    @Input() items;

    ngOnInit(): void {

    }

}
